import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { environment } from '../../../../../environments/environment';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { TogglePasswordService } from '../../services/toggle-password.service';
import { AlertMessageInterface } from '../../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  control: FormControl;
  resetPasswordFormSubmitted: boolean;
  errorMessage: string;
  token: string;
  environment = environment;
  captchaToken: string;
  captchaKey: string;
  constHelper = ConstsHelper;
  errors: any = {
    newPassword: {
      required: `Ce champ est obligatoire.`,
      pattern: `Votre mot de passe doit contenir au moins 10 caractères, avec une majuscule, une minuscule, un chiffre et un caractère spécial.`
    },
    confirmationNewPassword: {
      required: `Ce champ est obligatoire.`,
    }
  };
  vitrineUrl?: string;
  breadcrumbDetails: any = [
    {
      url: environment.data.vitrineUrl,
      label: `Accueil`
    },
    {
      url: `/connexion`,
      label: `Identification`
    },
    {
      url: null,
      label: `Réinitialiser le mot de passe`
    }
  ];
  
  brand?: string;

  constructor(
      private store: Store<any>,
      private router: Router,
      private activateRoute: ActivatedRoute,
      private formBuilder: FormBuilder,
      private loginService: LoginService,
      public togglePasswordService: TogglePasswordService
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.vitrineUrl = environment.data.vitrineUrl;
    this.token = null;
    this.errorMessage = null;
    this.captchaKey = null;
    this.captchaToken = null;
    if (this.activateRoute.snapshot.params['token'] && this.activateRoute.snapshot.params['token'].length >= 32) {
      this.token = this.activateRoute.snapshot.params['token'];
      this.captchaKey = environment.data.captchaKey;
      this.loginService.checkToken(this.token).subscribe(response => {
        this.initForms();
      }, error => {
        const alertMessage = ({ message: 'Le lien de réinitialisation du mot de passe a expiré. Cliquez sur "Mot de passe oublié" pour en recevoir un nouveau.', code: 400 }) as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
        this.router.navigate(['/connexion']);
      });
    } else {
      this.router.navigate(['/connexion']);
    }
  }

  initForms() {
    this.control = this.formBuilder.control('', Validators.required);
    this.resetPasswordForm = this.formBuilder.group({});
    this.resetPasswordForm.addControl('token', this.formBuilder.control(this.token, [Validators.required]));
    this.resetPasswordForm.addControl('newPassword', this.formBuilder.control('', [Validators.required, Validators.pattern(this.constHelper.passwordPattern)]));
    this.resetPasswordForm.addControl('confirmationNewPassword', this.formBuilder.control('', [Validators.required]));
  }

  send() {
    this.resetPasswordFormSubmitted = true;
    this.errorMessage = null;
    if (this.resetPasswordForm.valid) {
      this.resetPasswordFormSubmitted = false;
      if (this.resetPasswordForm.get('newPassword').value !== this.resetPasswordForm.get('confirmationNewPassword').value) {
        this.errorMessage = 'Les mots de passe saisis ne sont pas identiques.';
      } else {
        this.loginService.resetPassword(this.resetPasswordForm.get('newPassword').value, this.resetPasswordForm.get('token').value, this.captchaKey, this.captchaToken).subscribe(
            response => {
              const alertMessage = ({ message: 'Votre nouveau mot de passe a bien été enregistré. Vous pouvez l\'utiliser pour vous connecter.', code: 200 }) as AlertMessageInterface;
              this.store.dispatch(new GetAlertMessage(alertMessage));
              this.router.navigate(['/connexion']);
            }, error => {
              const alertMessage = ({ message: 'Le lien de réinitialisation du mot de passe a expiré. Cliquez sur "Mot de passe oublié" pour en recevoir un nouveau.', code: 400 }) as AlertMessageInterface;
              this.store.dispatch(new GetAlertMessage(alertMessage));
              this.router.navigate(['/connexion']);
              this.initForms();
            }
        );

      }
    }
  }

  resolved(captchaResponse: string) {
    this.captchaToken = captchaResponse;
    if (this.captchaToken && this.resetPasswordFormSubmitted) {
      this.send();
    }
  }

  onLoginClick(captchaRef: any): void {
    this.resetPasswordFormSubmitted = true;
    captchaRef.reset();
    captchaRef.execute();
  }

  errored(captchaRef: any) {
    captchaRef.reset();
    captchaRef.execute();
  }

  backToLoginPage() {
    this.router.navigate(['/connexion']);
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.resetPasswordForm.controls[formControlName].invalid) {
      Object.keys(this.resetPasswordForm.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
